import { PageHeader, Tooltip, message, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  TableItem,
  ButtonItem,
  ModalItem,
  Form,
  FormItem,
  InputItem,
  ErrorItem,
  SegmentedItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
} from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { CloseCircleOutlined, EyeOutlined } from "@ant-design/icons";
import VistaPrevia from "./VistaPrevia/VistaPrevia";

moment.locale("es");

class TraspasoEntreAlmacenes extends Component {
  formRefCancelar = React.createRef();
  state = {
    todasOrdenesDeTraspasoEntreAlmacenes: [],
    loading: false,
    modalVistaPrevia: false,
    modalVistaPreviaId: null,
    modalCancelar: false,
    modalCancelarId: null,
    valor: 1,
  };
  componentDidMount() {
    this.consultarTraspasoEntreAlmacenes();
  }
  consultarTraspasoEntreAlmacenes() {
    this.setState({ loading: true });
    axios
      .post(
        "traspasoEntreAlmacenes/selectOrdenes",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasOrdenesDeTraspasoEntreAlmacenes: res.data.map(valueT => {
              return {
                ...valueT,
                usuario: valueT.usuario.nombre + ' ' + valueT.usuario.apellidoPaterno + ' ' + valueT.usuario.apellidoMaterno,
                proyectoOrigen: valueT.proyectoOrigen.nombre,
                proyectoDestino: valueT.proyectoDestino.nombre,
              }
            }),
          });
        }
      });
  }
  agregarOrdenDeTraspasoEntreAlmacenes() {
    this.props.history.push("/panel/agregarOrdenDeTraspasoEntreAlmacenes");
  }
  abrirModalCancelar(id) {
    this.setState({ modalCancelar: true, modalCancelarId: id });
  }
  cerrarModalCancelar() {
    this.setState({ modalCancelar: false, modalCancelarId: null });
    if (this.formRefCancelar.current) {
      this.formRefCancelar.current.resetFields();
    }
  }
  onFinishFailedCancelar(e) {
    ErrorItem(e);
  }
  cancelarOrden(values) {
    this.setState({ loading: true });
    axios
      .post(
        "traspasoEntreAlmacenes/cancelarTraspasoEntreAlmacenes",
        {
          traspasoId: this.state.modalCancelarId,
          empresaId: this.props.empresaId,
          motivo: values.motivo || undefined,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Traspaso cancelado");
          NotificacionPolizas(res.data.polizasId);
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.cerrarModalCancelar();
        } else {
          message.error(res.data.message ? res.data.message : "Sucedio un error y no se pudo cancelar");
        }
        this.consultarTraspasoEntreAlmacenes();
      });
  }
  cerrarVistaPrevia() {
    this.setState({
      modalVistaPrevia: false,
      modalVistaPreviaId: null,
    });
  }
  render() {
    const isMobile = window.innerWidth <= 1000;
    const columns = [
      {
        title: "Numero",
        dataIndex: "numero",
        responsive: ["md"],
        key: "numero",
        sorter: (a, b) => {
          if (a.numero < b.numero) {
            return -1;
          }
          if (a.numero > b.numero) {
            return 1;
          }
          return 0;
        },
        buscar: "numero",
        width: "10%",
        render: (value, record) =>
          record.serie ? `${record.serie} - ${record.numero || ""}` : (record.numero || ""),
      },
      {
        title: "Origen",
        dataIndex: "proyectoOrigen",
        key: "proyectoOrigen",
        sorter: (a, b) => {
          if (a.proyectoOrigen < b.proyectoOrigen) {
            return -1;
          }
          if (a.proyectoOrigen > b.proyectoOrigen) {
            return 1;
          }
          return 0;
        },
        buscar: "proyectoOrigen",
        width: "20%",
      },
      {
        title: "Destino",
        dataIndex: "proyectoDestino",
        key: "proyectoDestino",
        sorter: (a, b) => {
          if (a.proyectoDestino < b.proyectoDestino) {
            return -1;
          }
          if (a.proyectoDestino > b.proyectoDestino) {
            return 1;
          }
          return 0;
        },
        buscar: "proyectoDestino",
        width: "20%",
      },
      {
        title: "Fecha Traspaso",
        dataIndex: "fechaTraspaso",
        key: "fechaTraspaso",
        sorter: (a, b) => {
          if (moment(a.fechaTraspaso) < moment(b.fechaTraspaso)) {
            return -1;
          }
          if (moment(a.fechaTraspaso) > moment(b.fechaTraspaso)) {
            return 1;
          }
          return 0;
        },
        render: (value) => value ? moment(value).locale("es").format("ll") : "",
        width: "10%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Fecha Registro",
        dataIndex: "createdAt",
        key: "createdAt",
        sorter: (a, b) => {
          if (moment(a.createdAt) < moment(b.createdAt)) {
            return -1;
          }
          if (moment(a.createdAt) > moment(b.createdAt)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale("es").format("ll"),
        width: "10%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Responsable",
        dataIndex: "usuario",
        responsive: ["md"],
        key: "usuario",
        sorter: (a, b) => {
          if (a.usuario < b.usuario) {
            return -1;
          }
          if (a.usuario > b.usuario) {
            return 1;
          }
          return 0;
        },
        buscar: "usuario",
        width: "15%",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        responsive: ["md"],
        render: (value) => {
          if (value === 0) {
            return <Tag color="red" className="square-tag">Cancelado</Tag>;
          }
          if (value === 1) {
            return <Tag color="green" className="square-tag">Vigente</Tag>;
          }
          return null;
        },
        width: "7%",
        ellipsis: true,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: isMobile ? "20%" : "10%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record, index) => {
          let buttons = [];

          buttons.push(
            <Tooltip key={`ver-${index}`} title="Ver Detalle" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                azul
                icon={<EyeOutlined />}
                onClick={() => this.setState({ modalVistaPrevia: true, modalVistaPreviaId: record._id })}
              >
              </ButtonItem>
            </Tooltip>
          );

          if (record.estado !== 0 && this.props.permisoCancelarTraspasoEntreAlmacenes) {
            buttons.push(
              <Tooltip key={`cancelar-${index}`} title="Cancelar Traspaso" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<CloseCircleOutlined />}
                  onClick={() => this.abrirModalCancelar(record._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      }
    ];
    return (
      <>
        <PageHeader
          title="Traspaso Entre Almacenes"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Vigentes', value: 1 }, { label: 'Cancelados', value: 0 }, { label: 'Todos', value: 2 }]}
                  onChange={(value) => this.setState({ valor: value })}
                  value={this.state.valor}
                />
              }
              {this.props.permisoAgregarTraspasoEntreAlmacenes &&
                <ButtonItem
                  type="primary"
                  key="agregarOrdenDeTraspasoEntreAlmacenes"
                  olivo
                  onClick={this.agregarOrdenDeTraspasoEntreAlmacenes.bind(this)}
                  style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                >
                  Agregar Traspaso Entre Almacenes
                </ButtonItem>
              }
            </>
          }
        />
        <TableItem
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasOrdenesDeTraspasoEntreAlmacenes.filter((value) => {
            if (this.state.valor === 2) return true;
            return value.estado === this.state.valor;
          })}
          columns={columns}
          pagination={false}
          onRow={(record) => ({
            onDoubleClick: () => this.setState({ modalVistaPrevia: true, modalVistaPreviaId: record._id }),
          })}
        />
        <VistaPrevia
          visible={this.state.modalVistaPrevia}
          id={this.state.modalVistaPreviaId}
          cerrarVistaPrevia={this.cerrarVistaPrevia.bind(this)}
        />
        <ModalItem
          title="Cancelar Traspaso"
          visible={this.state.modalCancelar}
          spinning={this.state.loading}
          onCancel={this.cerrarModalCancelar.bind(this)}
          paddingTop
        >
          <Form
            ref={this.formRefCancelar}
            name="cancelarTraspaso"
            layout
            onCancel={this.cerrarModalCancelar.bind(this)}
            onFinish={this.cancelarOrden.bind(this)}
            onFinishFailed={this.onFinishFailedCancelar.bind(this)}
          >
            <FormItem
              label="Motivo"
              name="motivo"
              margin
              pattern
              max={500}
            >
              <InputItem placeholder="Motivo de cancelación (opcional)" />
            </FormItem>
            <div
              style={{
                display: "flex",
                justifyContent: "right",
                marginTop: 20,
                marginBottom: 10,
              }}
            >
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar Traspaso
              </ButtonItem>
            </div>
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarTraspasoEntreAlmacenes: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6478f2830d24b4b09c994352")?.activado,
    permisoCancelarTraspasoEntreAlmacenes: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a10489b2b041233f02a6fe7")?.activado,
  };
};

export default connect(mapStateToProps)(TraspasoEntreAlmacenes);
